const update_sql7 = [
    'DROP INDEX IF EXISTS idx_msg_tid',
    'CREATE INDEX idx_msg_tid ON t_msg(tid);',
];
export default update_sql7;
